import { SET_ERROR } from "./constants";

export const setLoginError = (message) => ({
  type: SET_ERROR,
  payload: message,
});
